<template>
  <div>
    <h1 class="my-5 text-4xl font-extrabold tracking-tight text-gray-900">
      Veuillez entrer les informations du produit sinistré
    </h1>

    <ManualClaimProductFields v-model="manualProductValues" />

    <div class="mt-5 flex justify-between gap-5">
      <GenericButton @click="previousStep" secondary no-scaling class="mr-2">Précédent</GenericButton>
      <div class="pl-2">
        <NextButton @click="nextStep" :disabled="!requiredFieldsFilled" :saving="saving" />
      </div>
    </div>
  </div>
</template>

<script>
import {
  ClaimDeclarationFormStep as Step,
  ClaimDeclarationFormNextButton as NextButton,
  GenericButton,
} from "@estaly/ui";
import ManualClaimProductFields, {
  MANUAL_PRODUCT_FIELDS,
  MANUAL_PRODUCT_FORM_DATA_KEYS,
  emptyManualProductValues,
} from "@/components/claim/form/ManualClaimProductFields.vue";
import { mapGetters } from "vuex";

export default {
  extends: Step,
  components: {
    GenericButton,
    NextButton,
    ManualClaimProductFields,
  },
  data() {
    return {
      manualProductValues: emptyManualProductValues(),
      requiredFieldsFilled: false,
    };
  },
  computed: {
    ...mapGetters("claimDeclarations", ["isProductlessPlanSale"]),
  },

  watch: {
    manualProductValues: {
      deep: true,
      handler(values) {
        MANUAL_PRODUCT_FIELDS.forEach((field) => {
          this.setFormData(MANUAL_PRODUCT_FORM_DATA_KEYS[field], values[field]);
        });
        this.updateRequiredFieldsFilled();
      },
    },
    currentStep(step, previous) {
      if (step !== this.componentStep) return;
      if (this.isProductlessPlanSale) return;
      // Clean & skip
      this.save();
      previous < step ? this.$emit("next") : this.$emit("previous");
    },
  },
  methods: {
    updateRequiredFieldsFilled() {
      this.requiredFieldsFilled = MANUAL_PRODUCT_FIELDS.every((field) =>
        this.formData.get(MANUAL_PRODUCT_FORM_DATA_KEYS[field]),
      );
    },
  },
};
</script>
